export default __webpack_public_path__ + "static/media/pictogramBeaconCards128.a833b2ad.svg";